import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation updateFastCashStateMutation(
    $input: UpdateFastCashStateInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    updateFastCashState(input: $input) {
      errorMessage
      successMessage
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
    }
  }
`;

const updateFastCashState = (environment, params, args = {}) => {
  const {
    fastCashId,
    fastCashState,
    byAuth0Id,
    beforeDate,
    afterDate,
    bankAccountIdEq,
    stateEq,
  } = params;
  const inputParams = { fastCashId, state: fastCashState };

  return commit(environment, {
    mutation,
    variables: {
      input: inputParams,
      afterDate,
      beforeDate,
      bankAccountIdEq,
      stateEq,
      byAuth0Id,
    },
    ...args,
  });
};

export default updateFastCashState;
